import { AxiosInstance } from "axios";
import { useDispatch, useStore } from "react-redux";
import {
  ChatbotSessionMessage,
  CreateAbsencesRequestService,
  CreateAbsencesResponseService,
  GetAbsencesResponseService,
  GetOneAbsenceResponseService,
} from "./Absences.type";

export default class AbsencesServices {
  private axios: AxiosInstance;
  public dispatch = useDispatch();
  public getStore = useStore();
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  // CREATE A NEW ABSENCES TURN
  public async CreateAbsencesService(
    req: CreateAbsencesRequestService,
  ): Promise<CreateAbsencesResponseService> {
    const url: string = "/absentee-appointments/admin";
    return this.axios.post(url, req);
  }




  // DELETE ABSENCE
  public async deleteAbsence(id: string): Promise<void> {
    const url: string = `/absentee-appointments/admin/${id}`;
    return this.axios.delete(url);
  }

  // EDIT ABSENCE
  public async editAbsence(
    req: CreateAbsencesRequestService,
    id: string,
  ): Promise<CreateAbsencesResponseService> {
    const url: string = `/absentee-appointments/admin/${id}`;
    return this.axios.patch(url, req);
  }

  // GET ABSENCES TURNS
  public async GetAbsencesTurns(
    page: number,
    items: number,
  ): Promise<GetAbsencesResponseService> {
    let chosenCompany: string;
    if (this.getStore.getState().user.currentCompany) {
      chosenCompany = this.getStore.getState().user.currentCompany.id;
    }
    else {
      chosenCompany = this.getStore.getState().user.companies[0].id;
    }
    const url: string = `absentee-appointments/admin?items=${items}&page=${page}&companyId=${chosenCompany}`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // GET AN ABSENCE TURN
  public async GetAbsenceTurn(
    id: string,
  ): Promise<GetOneAbsenceResponseService> {
    const url: string = `absentee-appointments/admin/${id}`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // GET Employe eAbsences
  public async GetEmployeeAbsences(
    id: string,
    items: number,
    page: number,
  ): Promise<GetAbsencesResponseService> {
    const url: string = `absentee-appointments/admin/employee/${id}?items=${items}&page=${page}`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // GET Absences Completed
  public async GetAbsencesCompleted(
    items: any,
    data: any,
    signal?: AbortSignal
  ): Promise<GetAbsencesResponseService> {
    const pageParam = data.page !== undefined ? `&page=${data.page}` : '';
    const fromParam = data.fromParam !== undefined ? `&fromParam=${data.fromParam}` : '';
    const toParam = data.toParam !== undefined ? `&toParam=${data.toParam}` : '';
    const search = data.searchQuery !== undefined ? `&search=${data.searchQuery}` : "";
    const status = data.status !== undefined ? `&status=${data.status}` : "";

    const url: string = `absentee-appointments/admin/completed?items=${items}${pageParam}${fromParam}${toParam}${search}${status}`;
    return this.axios.get(url, { method: "get", signal });
  }



  // GET Absences solicitudes (Son los que no estan completados ni cancelados)
  public async getAbsencesRequested(
    items: any,
    data: any,
    signal?: AbortSignal
  ): Promise<GetAbsencesResponseService> {
    //const url: string = `absentee-appointments/admin/requested?items=${items}&page=${page}`;
    const pageParam = data.page !== undefined ? `&page=${data.page}` : '';
    const fromParam = data.fromParam !== undefined ? `&fromParam=${data.fromParam}` : '';
    const toParam = data.toParam !== undefined ? `&toParam=${data.toParam}` : '';
    const search = data.searchQuery !== undefined ? `&search=${data.searchQuery}` : "";
    const status = data.status !== undefined ? `&status=${data.status}` : "";

    const url: string = `absentee-appointments/admin/requested?items=${items}${pageParam}${fromParam}${toParam}${search}${status}`;
    return this.axios.get(url, { method: "get", signal });
  }
  // GET Absences solicitudes (Todos los turnos que estan completados, cancelados, no se presentaron o incompletos)
  // public async getAbsencesHistory(
  //   items: any,
  //   data: any,
  //   signal: AbortSignal
  // ): Promise<GetAbsencesResponseService> {
  //   const pageParam = data.page !== undefined ? `&page=${data.page}` : '';
  //   const fromParam = data.fromParam !== undefined ? `&fromParam=${data.fromParam}` : '';
  //   const toParam = data.toParam !== undefined ? `&toParam=${data.toParam}` : '';

  //   const url: string = `absentee-appointments/admin/history?items=${items}${pageParam}${fromParam}${toParam}`;
  //   return this.axios.get(url, { method: "get", signal });
  // }



  // Add Absence Certificate
  public async AddAbsenceCertificate(
    req: { certificate: File },
    id: string,
  ): Promise<void> {
    const url: string = `/absentee-appointments/admin/${id}/upload`;
    const formData = new FormData();
    formData.append("file", req.certificate);
    formData.append("fileName", req.certificate.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.axios.post(url, formData, config);
  }

  //CHATBOT
  public async createDecideLavorisRequest(
    req: CreateAbsencesRequestService,
  ): Promise<CreateAbsencesResponseService> {
    const url: string = "/absentee-appointments/admin/define-lavoris";
    return this.axios.post(url, req);
  }
  //CHATBOT CLOSE SESSION MESSAGE
  public async getChatbotClosedMessageByAbsId(absentee_appointment: string | undefined): Promise<ChatbotSessionMessage> {
    const url: string = `/absentee-appointments/chatbot/closed-chatbot-session-message?id=${absentee_appointment}`;
    return this.axios.get(url);
  }


  ///REPORTES
  public async getReportes(from: string, to: string, company_id: string): Promise<any[]> {
    const url: string = `/absentee-appointments/admin/report?from=${from}&to=${to}&company_id=${company_id}`;
    return this.axios.get(url);
  }

  public async hasEmployeePendingAbsenteeAppointments(employeeId: string | undefined): Promise<boolean> {
    const url: string = `/absentee-appointments/hasPendingAbsenteeAppointments/${employeeId}`;
    return this.axios.get(url);
  }
}
